import { TicketType } from '../models/ticket-type.enum';
import type { ZoneType } from '../models/zone-type.enum';
import { ZoneTypeHelper } from './zone-type.helper';

export class TicketHelper {
  // This method returns a text containing the ticked and number of zones selected by the user. It is used in the PriceCalculatorPage component.
  public static getSelectedTicketWithNumberOfZonesText(ticketType: TicketType, zones: ZoneType[], translationFunc: (key: string) => string): string {
    const zoneDescription = ZoneTypeHelper.toString(zones, translationFunc);
    if (ticketType === TicketType.SingleTicket) {
      return `${translationFunc('common.products.types.singleticket').toLowerCase()} ${zoneDescription}`;
    }
    if (ticketType === TicketType.DayTicket) {
      return `${translationFunc('common.products.types.dayticket').toLowerCase()} ${zoneDescription} 24 ${translationFunc('common.products.timevalidity.units.hourslong').toLowerCase()}`;
    }
    if (ticketType === TicketType.ThreeDayTicket) {
      return `${translationFunc('common.products.types.dayticket').toLowerCase()} ${zoneDescription} 72 ${translationFunc('common.products.timevalidity.units.hourslong').toLowerCase()}`;
    }
    if (ticketType === TicketType.ThirtyDays) {
      return `${translationFunc('common.products.types.periodticket').toLowerCase()} ${zoneDescription} 30 ${translationFunc('common.products.timevalidity.units.days').toLowerCase()}`;
    }
    if (ticketType === TicketType.NinetyDays) {
      return `${translationFunc('common.products.types.periodticket').toLowerCase()} ${zoneDescription} 90 ${translationFunc('common.products.timevalidity.units.days').toLowerCase()}`;
    }
    if (ticketType === TicketType.ThreeHundredSixtyFiveDays) {
      return `${translationFunc('common.products.types.periodticket').toLowerCase()} ${zoneDescription} 365 ${translationFunc('common.products.timevalidity.units.days').toLowerCase()}`;
    }
    return '';
  }
}
